
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlP as ObiOwnShipControlPElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-p.js';
 
 
 

 
 export const ObiOwnShipControlP = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-p',
   elementClass: ObiOwnShipControlPElement,
   events: {
     
   }
  });
 
 